import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, defaultWindow, toIso, when } from './api';
const short = (t, n) => {
  const s = String(t || '').replace(/\s+/g, ' ').trim();
  return s.length > n ? s.slice(0, n - 1).trimEnd() + '…' : s;
};
const STATUS = {
  pending: 'Waiting for review',
  approved: 'Approved',
  published: 'Published',
  failed: 'Failed',
  rejected: 'Rejected'
};

/**
 * Conversations: several managed accounts in one exchange. The AI proposes the whole sequence;
 * you edit, remove or reorder parts, approve them, then schedule them in order (replies always
 * after the post they answer). Each part posts with the Voucha Team badge. attrs: state
 */
export default class ConversationsTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.list = null;
    this.open = null; // {conversation, parts}
    this.form = null;
    this.busy = {};
    this.edits = {};
    this.window = defaultWindow(24);
    this.loadList();
  }
  loadList() {
    return api('GET', '/conversations').then(r => this.list = r.conversations || []).catch(() => this.list = []).finally(() => m.redraw());
  }
  load(id) {
    return api('GET', '/conversations/' + id).then(r => {
      this.open = r;
      this.edits = {};
    }).catch(() => {}).finally(() => m.redraw());
  }
  run(key, p) {
    this.busy[key] = true;
    m.redraw();
    return p.catch(() => {}).finally(() => {
      this.busy[key] = false;
      m.redraw();
    });
  }
  name(id) {
    const a = (this.attrs.state.accounts || []).find(x => x.userId === id);
    return a ? a.displayName : '#' + id;
  }
  view() {
    if (this.open) return this.detail();
    const accounts = (this.attrs.state.accounts || []).filter(a => a.status === 'active');
    return m("div", {
      className: "VEC-conversations"
    }, m("div", {
      className: "VEC-row-head"
    }, m("p", {
      className: "VEC-help"
    }, "Plan an exchange between two or more managed accounts, on a new topic or in an existing discussion. Each part is reviewed like any draft and posts with the Voucha Team badge."), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      onclick: () => this.form = this.form ? null : {
        discussion: '',
        topic: '',
        tags: [],
        accounts: [],
        turns: 4,
        instructions: ''
      }
    }, "New conversation")), this.form ? this.newForm(accounts) : null, !this.list ? m(LoadingIndicator, null) : this.list.length ? m("ul", {
      className: "VEC-list"
    }, this.list.map(c => m("li", {
      className: "VEC-account",
      key: c.id
    }, m("div", {
      className: "VEC-account-main"
    }, m("div", {
      className: "VEC-account-text"
    }, m("a", {
      className: "VEC-sug-title",
      href: "#",
      onclick: e => {
        e.preventDefault();
        this.load(c.id);
      }
    }, c.title || c.topic || 'Conversation #' + c.id), m("div", {
      className: "VEC-muted"
    }, c.accountIds.map(id => this.name(id)).join(', '), " \xB7 ", Object.keys(c.counts).map(k => c.counts[k] + ' ' + (STATUS[k] || k).toLowerCase()).join(', '))), m(Button, {
      className: "Button",
      onclick: () => this.load(c.id)
    }, "Open"))))) : m("p", {
      className: "VEC-empty"
    }, "No conversations yet."));
  }
  newForm(accounts) {
    const f = this.form;
    const tags = (app.store.all('tags') || []).filter(t => !(t.isHidden && t.isHidden())).sort((a, b) => a.name().localeCompare(b.name()));
    return m("div", {
      className: "VEC-card"
    }, m("h3", null, "New conversation"), m("div", {
      className: "VEC-fields"
    }, m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "In an existing discussion (optional)"), m("input", {
      className: "FormControl",
      value: f.discussion,
      placeholder: "Paste a discussion link, or leave empty to start a new discussion",
      oninput: e => f.discussion = e.target.value
    })), !f.discussion ? [m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Topic"), m("input", {
      className: "FormControl",
      value: f.topic,
      placeholder: "e.g. Is it better to rent or buy in Abuja right now?",
      oninput: e => f.topic = e.target.value
    })), m("div", {
      className: "VEC-field is-wide"
    }, m("span", null, "Tags"), m("div", {
      className: "VEC-tags"
    }, tags.map(t => {
      const on = f.tags.includes(t.id());
      return m("button", {
        type: "button",
        className: 'VEC-tag' + (on ? ' is-on' : ''),
        onclick: () => f.tags = on ? f.tags.filter(x => x !== t.id()) : [...f.tags, t.id()]
      }, t.name());
    })))] : null, m("div", {
      className: "VEC-field is-wide"
    }, m("span", null, "Accounts taking part (2 or more)"), m("div", {
      className: "VEC-tags"
    }, accounts.map(a => {
      const on = f.accounts.includes(a.userId);
      return m("button", {
        type: "button",
        className: 'VEC-tag' + (on ? ' is-on' : ''),
        onclick: () => f.accounts = on ? f.accounts.filter(x => x !== a.userId) : [...f.accounts, a.userId]
      }, a.displayName);
    }))), m("label", {
      className: "VEC-field"
    }, m("span", null, "Number of parts"), m("input", {
      className: "FormControl",
      type: "number",
      min: "2",
      max: "10",
      value: f.turns,
      oninput: e => f.turns = e.target.value
    })), m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Instructions (optional)"), m("input", {
      className: "FormControl",
      value: f.instructions,
      placeholder: "e.g. one account sceptical, one practical; end with a question for members",
      oninput: e => f.instructions = e.target.value
    }))), m("div", {
      className: "VEC-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-magic",
      loading: this.busy.create,
      disabled: !this.attrs.state.aiReady || f.accounts.length < 2,
      onclick: () => this.run('create', api('POST', '/conversations', f).then(r => {
        this.form = null;
        this.open = r;
        this.loadList();
      }))
    }, "Write the conversation"), m(Button, {
      className: "Button",
      onclick: () => this.form = null
    }, "Cancel")));
  }
  detail() {
    const {
      conversation: c,
      parts
    } = this.open;
    const byId = {};
    parts.forEach((p, i) => byId[p.id] = i);
    const anyPending = parts.some(p => p.status === 'pending' || p.status === 'failed');
    const allApproved = parts.length && parts.every(p => p.status === 'approved' || p.status === 'published');
    const published = parts.some(p => p.status === 'published');
    return m("div", {
      className: "VEC-conversation"
    }, m(Button, {
      className: "Button Button--text",
      icon: "fas fa-arrow-left",
      onclick: () => {
        this.open = null;
        this.loadList();
      }
    }, "All conversations"), m("h3", null, c && (c.title || c.topic) || 'Conversation'), c && c.discussionId ? m("p", {
      className: "VEC-help"
    }, "In ", m("a", {
      href: '/d/' + c.discussionId,
      target: "_blank",
      rel: "noopener"
    }, "this discussion"), ".") : null, m("ol", {
      className: "VEC-turns"
    }, parts.map((p, i) => this.turn(p, i, byId, parts))), m("div", {
      className: "VEC-card"
    }, m("div", {
      className: "VEC-actions"
    }, anyPending ? m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-check-double",
      loading: this.busy.approve,
      onclick: () => this.act('approve')
    }, "Approve all") : null, !published ? m(Button, {
      className: "Button",
      icon: "fas fa-redo",
      loading: this.busy.regenerate,
      disabled: !this.attrs.state.aiReady,
      onclick: () => {
        if (window.confirm('Rewrite every part? Your edits will be lost.')) this.act('regenerate', {
          turns: parts.length
        });
      }
    }, "Rewrite all with AI") : null, m(Button, {
      className: "Button Button--text",
      onclick: () => this.remove(c)
    }, "Delete conversation")), allApproved ? m("div", {
      className: "VEC-schedule-row"
    }, m("span", {
      className: "VEC-muted"
    }, "Schedule in order, starting between"), m("input", {
      type: "datetime-local",
      className: "FormControl",
      value: this.window.earliest,
      oninput: e => this.window.earliest = e.target.value
    }), m("span", {
      className: "VEC-muted"
    }, "and"), m("input", {
      type: "datetime-local",
      className: "FormControl",
      value: this.window.latest,
      oninput: e => this.window.latest = e.target.value
    }), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-clock",
      loading: this.busy.schedule,
      onclick: () => this.act('schedule', {
        earliest: toIso(this.window.earliest),
        latest: toIso(this.window.latest)
      })
    }, "Schedule")) : null, allApproved ? m("p", {
      className: "VEC-help VEC-pastnote"
    }, "A time in the past publishes on the next run, dated to that time.") : m("p", {
      className: "VEC-help"
    }, "Approve every part to schedule the conversation. Remove parts you don't want with Delete.")));
  }
  turn(p, i, byId, parts) {
    const e = this.edits[p.id] = this.edits[p.id] || {
      title: p.title || '',
      content: p.content || ''
    };
    const changed = e.title !== (p.title || '') || e.content !== (p.content || '');
    const posts = this.open && this.open.posts || [];
    const parent = p.parentDraftId != null && byId[p.parentDraftId] != null ? parts[byId[p.parentDraftId]] : null;
    const post = p.replyToPostId ? posts.find(x => x.id === p.replyToPostId) : null;
    // what it answers, with that post's words, so it's clear where the reply lands
    let replyTo;
    let quote = null;
    if (p.kind === 'discussion') {
      replyTo = 'starts the discussion';
    } else if (parent) {
      replyTo = 'replies to part ' + (byId[p.parentDraftId] + 1) + ' (' + this.name(parent.accountId) + ')';
      quote = {
        who: this.name(parent.accountId),
        text: short(parent.kind === 'discussion' ? parent.title || parent.content : parent.content, 140)
      };
    } else if (post) {
      replyTo = 'replies to ' + post.author + "'s comment";
      quote = {
        who: post.author,
        text: post.excerpt
      };
    } else if (p.replyToNumber) {
      replyTo = 'replies to comment #' + p.replyToNumber;
    } else {
      replyTo = 'replies in the discussion, to no one in particular';
    }
    const editable = p.status !== 'published';
    const scheduled = p.schedule && ['queued', 'running', 'paused'].includes(p.schedule.status);
    const current = p.parentDraftId ? 'T' + p.parentDraftId : p.replyToPostId ? 'P' + p.replyToPostId : 'discussion';
    const options = [];
    if (this.open && this.open.conversation && this.open.conversation.discussionId) {
      options.push(['discussion', 'The discussion (no one in particular)']);
      posts.forEach(x => options.push(['P' + x.id, (x.number === 1 ? 'Opening post' : 'Comment #' + x.number) + ' · ' + x.author + ': ' + short(x.excerpt, 70)]));
    }
    parts.slice(0, i).forEach((x, k) => options.push(['T' + x.id, 'Part ' + (k + 1) + ' · ' + this.name(x.accountId) + ': ' + short(x.kind === 'discussion' ? x.title || x.content : x.content, 70)]));
    const picker = editable && p.kind === 'reply' && !scheduled && options.length > 1 ? m("label", {
      className: "VEC-target-pick"
    }, m("span", {
      className: "VEC-muted"
    }, "Replying to"), m("select", {
      className: "FormControl",
      value: current,
      disabled: this.busy['target' + p.id],
      onchange: ev => {
        const target = ev.target.value;
        if (p.status === 'approved' && !window.confirm('Change what this part replies to? It will need approving again.')) {
          ev.target.value = current;
          return;
        }
        this.run('target' + p.id, api('POST', '/conversations/' + this.open.conversation.id + '/target', {
          draft: p.id,
          target
        }).then(r => {
          this.open = r;
        }, err => {
          ev.target.value = current;
          throw err;
        }));
      }
    }, options.map(_ref => {
      let [v, label] = _ref;
      return m("option", {
        value: v,
        selected: v === current
      }, label);
    }))) : null;
    return m("li", {
      className: 'VEC-card VEC-turn is-' + p.status,
      key: p.id
    }, m("div", {
      className: "VEC-draft-head"
    }, m("strong", null, i + 1, ". ", this.name(p.accountId)), m("span", {
      className: "VEC-muted"
    }, replyTo), m("span", {
      className: 'VEC-pill is-' + p.status
    }, STATUS[p.status] || p.status), p.schedule && ['queued', 'running', 'paused'].includes(p.schedule.status) ? m("span", {
      className: "VEC-pill"
    }, m("i", {
      className: "fas fa-clock"
    }), " ", when(p.schedule.runAt)) : null, p.schedule && p.schedule.error ? m("span", {
      className: "VEC-flag"
    }, p.schedule.error) : null, editable ? m("span", {
      className: "VEC-turn-move"
    }, m(Button, {
      className: "Button Button--icon Button--text",
      icon: "fas fa-arrow-up",
      disabled: i === 0,
      onclick: () => this.move(parts, i, -1)
    }), m(Button, {
      className: "Button Button--icon Button--text",
      icon: "fas fa-arrow-down",
      disabled: i === parts.length - 1,
      onclick: () => this.move(parts, i, 1)
    })) : null), quote ? m("blockquote", {
      className: "VEC-target"
    }, m("strong", null, quote.who), " ", quote.text) : null, picker, p.kind === 'discussion' ? m("input", {
      className: "FormControl VEC-draft-title",
      value: e.title,
      disabled: !editable,
      oninput: ev => e.title = ev.target.value
    }) : null, m("textarea", {
      className: "FormControl VEC-content",
      rows: "4",
      value: e.content,
      disabled: !editable,
      oninput: ev => e.content = ev.target.value
    }), editable ? m("div", {
      className: "VEC-actions"
    }, changed ? m(Button, {
      className: "Button Button--primary",
      onclick: () => this.save(p, e)
    }, "Save", p.status === 'approved' ? ' (needs re-approval)' : '') : null, !changed && p.status === 'pending' ? m(Button, {
      className: "Button",
      onclick: () => this.draftAct(p, 'approve')
    }, "Approve") : null, m(Button, {
      className: "Button Button--text",
      onclick: () => this.removePart(p)
    }, "Delete part")) : p.publishedDiscussionId ? m("a", {
      href: '/d/' + p.publishedDiscussionId,
      target: "_blank",
      rel: "noopener"
    }, "Open on the forum") : null);
  }
  act(action, body) {
    const id = this.open.conversation.id;
    return this.run(action, api('POST', '/conversations/' + id + '/' + action, body || {}).then(r => {
      this.open = r;
      this.edits = {};
      if (action === 'schedule' && r.scheduled) app.alerts.show({
        type: 'success'
      }, 'Scheduled ' + r.scheduled.length + ' parts, first at ' + (r.scheduled[0] ? when(r.scheduled[0].runAt) : '—') + '.');
    }));
  }
  move(parts, i, dir) {
    const order = parts.map(p => p.id);
    const j = i + dir;
    [order[i], order[j]] = [order[j], order[i]];
    this.act('reorder', {
      order
    });
  }
  save(p, e) {
    return this.run('save' + p.id, api('POST', '/drafts/' + p.id, {
      title: e.title,
      content: e.content
    }).then(() => this.load(this.open.conversation.id)));
  }
  draftAct(p, action) {
    return this.run(action + p.id, api('POST', '/drafts/' + p.id + '/' + action).then(() => this.load(this.open.conversation.id)));
  }
  removePart(p) {
    if (!window.confirm('Delete this part? Replies to it will lose their target.')) return;
    this.run('del' + p.id, api('DELETE', '/drafts/' + p.id).then(() => this.load(this.open.conversation.id)));
  }
  remove(c) {
    if (!window.confirm('Delete this conversation and its unpublished parts? Published parts stay on the forum.')) return;
    this.run('delete', api('DELETE', '/conversations/' + c.id).then(() => {
      this.open = null;
      this.loadList();
    }));
  }
}